import React from 'react'
import PropTypes from 'prop-types'

import MyPropTyes from '@global/propTypes'

import { StyledIcon } from './styles'

const Icon = ({ name, circle, size, color, spin, disabled, onClick }) => (
  <StyledIcon
    className='material-icons notranslate'
    circle={circle}
    size={size}
    color={color}
    spin={spin}
    disabled={disabled}
    onClick={disabled ? null : onClick}
  >
    {name}
  </StyledIcon>
)

Icon.defaultProps = {
  onClick: null
}

Icon.propTypes = {
  name: PropTypes.string,
  circle: PropTypes.bool,
  size: MyPropTyes.size,
  color: MyPropTyes.color,
  disabled: PropTypes.bool,
  spin: PropTypes.bool,
  onClick: PropTypes.func
}

export default Icon
